import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useLocation } from "react-router-dom";
import { useQuotation } from "../context/QuotationContext";

const IDLE_MS = 2800;
const HeroIdleContext = createContext(false);

export function useHeroChromeIdle() {
  return useContext(HeroIdleContext);
}

function heroIsInWatchView() {
  const el = document.getElementById("inicio");
  if (!el) return false;
  const r = el.getBoundingClientRect();
  return r.top < 120 && r.bottom > window.innerHeight * 0.42;
}

function chromeBlocked() {
  if (document.querySelector('header[data-menu-open="true"]')) return true;
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return true;
  return false;
}

/** Oculta lo que cubre el video del home si no hay movimiento. */
export default function HeroIdleChrome({ children }) {
  const location = useLocation();
  const { isDrawerOpen } = useQuotation();
  const [idle, setIdle] = useState(false);
  const idleRef = useRef(false);
  const timerRef = useRef(0);
  const isHome = location.pathname === "/";

  useEffect(() => {
    idleRef.current = idle;
  }, [idle]);

  useEffect(() => {
    const root = document.documentElement;

    function apply(next) {
      if (idleRef.current === next) return;
      idleRef.current = next;
      setIdle(next);
      root.classList.toggle("hero-chrome-idle", next);
    }

    function hideIfIdle() {
      if (!isHome || isDrawerOpen || chromeBlocked() || !heroIsInWatchView()) {
        apply(false);
        return;
      }
      apply(true);
    }

    function bump() {
      apply(false);
      window.clearTimeout(timerRef.current);
      if (!isHome || isDrawerOpen) return;
      timerRef.current = window.setTimeout(hideIfIdle, IDLE_MS);
    }

    apply(false);
    if (!isHome) {
      return () => {
        window.clearTimeout(timerRef.current);
        root.classList.remove("hero-chrome-idle");
      };
    }

    const opts = { passive: true };
    const events = [
      "mousemove",
      "mousedown",
      "pointerdown",
      "keydown",
      "touchstart",
      "touchmove",
      "wheel",
      "scroll",
    ];
    events.forEach((name) => window.addEventListener(name, bump, opts));
    bump();

    return () => {
      events.forEach((name) => window.removeEventListener(name, bump));
      window.clearTimeout(timerRef.current);
      root.classList.remove("hero-chrome-idle");
      idleRef.current = false;
    };
  }, [isHome, isDrawerOpen]);

  return <HeroIdleContext.Provider value={idle}>{children}</HeroIdleContext.Provider>;
}
